<h2 mat-dialog-title [innerHTML]="data.title"></h2>
<mat-dialog-content class="mat-typography">
  @if (data.message) {
    <div class="mb-2" [innerHTML]="data.message"></div>
  }

  @if (data.warning) {
    <p>
      <strong class="warning">{{ data.warning }}</strong>
    </p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button [color]="data.confirmColor" [matDialogClose]="true">
    {{ data.confirmText }}
  </button>
  <button mat-raised-button class="me-2" [color]="data.cancelColor" [matDialogClose]="false">
    {{ data.cancelText }}
  </button>
</mat-dialog-actions>
